import { Component, forwardRef } from "react";
import Header from "../../../common_components/Header";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { receipt_list_search_action, shareEmail_action, getEmailData_action, getReceiptPdf_action, receiptShare_action }
  from "../../../actions/admin_module_action/registration_receipt_actions/receipt_action";
import {
  get_refund_type_amount_action, generate_refund_voucher_action, refund_update_action, refundShare_action, add_refund_action, delete_refund_action, get_receipt_list_action, getRefunedPdf_action
} from "../../../actions/admin_module_action/refund_action/refund_action.js";
import { downloadReport, toastError, toastSuccess } from "../../../utils/constants";
import AdminHeader from "../../../common_components/admin_module_header";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import Workbook from 'react-excel-workbook'
import Modal from "react-modal";
import Footerwithdr from '../../../common_components/Footerwithdr';
import HeaderWithLogo from "../../../common_components/header_with_logo";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";


const ExampleCustomInput = forwardRef(({ value, onClick, onChange, disabled }, ref) => (
  <input
    value={value}
    className="form-control"
    onClick={onClick}
    onChange={onChange}
    disabled={disabled}
    ref={ref}
  ></input>
));


class RefundList extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      exhibitor: "",
      RefundFromDate: "",
      RefundToDate: "",
      RefundNo: "",
      currentPage: 1,
      fileList: FileList | null,
      isOpen: false,
      recptList: [],
      excelList: [],
      isAllChecked: false,
      taxableAmount: 0,
      totalRefundAmt: 0,
      loginAccesslist: [],
      // isRightToAdd: false,
      // isRightToEdit: false,
      // isRightToView: false,

      //Error Msg
      checkBoxFlag: true
    }
    this.searchReceipt = this.searchReceipt.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.updateItem = this.updateItem.bind(this);
    // this.InputValidate = this.InputValidate.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleAllSelected = this.handleAllSelected.bind(this)
    this.onCreateExcel = this.onCreateExcel.bind(this)
    this.handleListClick = this.handleListClick.bind(this)
    this.handleView = this.handleView.bind(this)
    // this.handleShare = this.handleShare.bind(this)
    // this.toggleModal = this.toggleModal.bind(this)
    this.handleNewRefund = this.handleNewRefund.bind(this)
    this.calculateTotals = this.calculateTotals.bind(this)
    // this.handleRemoveFile = this.handleRemoveFile.bind(this)
    // this.getEmailData = this.getEmailData.bind(this)
    this.clearValue = this.clearValue.bind(this)
    this.onRefundDownload = this.onRefundDownload.bind(this)
    this.getWriteAccess = this.getWriteAccess.bind(this)
    this.getDownloadAccess = this.getDownloadAccess.bind(this)
    this.getSendAccess = this.getSendAccess.bind(this)
    this.getUpdateAccess = this.getUpdateAccess.bind(this)
  }

  componentDidMount() {
    this.searchReceipt()
    console.log("session storage loginDataSS", JSON.parse(sessionStorage.getItem('loginDataSS')))

    this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
    // this.setState({
    //   RefundFromDate: sessionStorage.getItem('ExhibitionFromDateSS'),
    //   RefundToDate: sessionStorage.getItem('ExhibitionToDateSS')
    // })
    // this.getEmailData()
    // this.setState({
    //   isRightToAdd: JSON.parse(sessionStorage.getItem('DummyLoginData')) != null &&
    //     JSON.parse(sessionStorage.getItem('DummyLoginData'))['accessRights'] != null &&
    //     JSON.parse(sessionStorage.getItem('DummyLoginData'))['accessRights'].find(obj => obj.ModuleId == 1 && obj.ModuleName == "Receipt").isAdd,
    //   isRightToEdit: JSON.parse(sessionStorage.getItem('DummyLoginData')) != null &&
    //     JSON.parse(sessionStorage.getItem('DummyLoginData'))['accessRights'] != null &&
    //     JSON.parse(sessionStorage.getItem('DummyLoginData'))['accessRights'].find(obj => obj.ModuleId == 1 && obj.ModuleName == "Receipt").isUpdate,
    //   isRightToView: JSON.parse(sessionStorage.getItem('DummyLoginData')) != null &&
    //     JSON.parse(sessionStorage.getItem('DummyLoginData'))['accessRights'] != null &&
    //     JSON.parse(sessionStorage.getItem('DummyLoginData'))['accessRights'].find(obj => obj.ModuleId == 1 && obj.ModuleName == "Receipt").isView,
    // })
    // const rights = JSON.parse(sessionStorage.getItem('DummyLoginData'))['accessRights'].find(obj => obj.ModuleId == 1 && obj.ModuleName == "Receipt")
    // console.log("zzzzzzzzzzzzzzzzzz", rights)
  }

  // Search Receipt 
  searchReceipt() {
    const { isLoading, exhibitor, RefundFromDate, RefundToDate, RefundNo, currentPage } = this.state
    // Input Validate before search
    // this.InputValidate()

    // if (exhibitor !== "" && RefundFromDate !== "" && RefundToDate !== "" && RefundNo !== "") {
    this.setState({ isLoading: true })
    this.props
      .get_receipt_list_action(exhibitor, RefundFromDate, RefundToDate, RefundNo)
      .then((data) => {
        if (data.error != 1) {
          this.setState({
            recptList: data.data,
          })
          setTimeout(() => {
            console.log("aaaaaaaaaaaaa", data.data);
            this.updateItem(currentPage)
            this.setState({ isLoading: false })
          }, 500);
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      });

  }

  //For Calculation All total Amounts in table 
  calculateTotals(list) {

    const { recptList, currentPage } = this.state


    let TaxableAmount = 0;
    let toatalSD = 0
    let totalCgst = 0;
    let totalIgst = 0;
    let totalSgst = 0;
    let TotalRefundAmt = 0;

    console.log("recptList", recptList)

    list.length > 0 && list.forEach((data) => {
      console.log("00000", data.TaxableAmount)

      TaxableAmount += Number(data.TaxableAmount);
      toatalSD += Number(data.SecurityDeposite);
      totalCgst += Number(data.CGST);
      totalIgst += Number(data.IGST);
      totalSgst += Number(data.SGST);
      TotalRefundAmt += Number(data.RefundAmount)
      console.log("00000", TaxableAmount)

    });

    this.setState({
      totalRefundAmt: TotalRefundAmt.toFixed(2),
      taxableAmount: TaxableAmount.toFixed(2),
      totalSD: toatalSD.toFixed(2)
    })
    return {
      TaxableAmount,
      totalCgst,
      totalIgst,
      totalSgst,
      TotalRefundAmt
    };
  }


  handleAllSelected(e) {
    const { recptList, isAllChecked } = this.state
    recptList.map(data => {
      if (e.target.checked) {
        data.is_checked = 1
        this.setState({ excelList: recptList, })
      } else {
        data.is_checked = 0
        this.setState({ excelList: [], })

      }
    })
    this.setState({ recptList: recptList, isAllChecked: !isAllChecked })

    const checkboxSelected = recptList.every(item => item.is_checked == 1)
    if (checkboxSelected) {
      this.setState({ checkBoxFlag: false })
    } else {
      this.setState({ checkBoxFlag: true })
    }
  }

  // Update Current Page
  updateItem(item) {
    const { recptList } = this.state
    this.setState({ currentPage: item });
    console.log("xyxyxyxyyxyxyyyxyx", item)
    const recordsPerPage = 10;
    const indexOfLastRecord = item * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
    const currentRecords = recptList.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(recptList.length / recordsPerPage)
    this.calculateTotals(currentRecords)
  }

  clearValue() {
    this.setState({
      exhibitor: "",
      RefundFromDate: "",
      RefundToDate: "",
      RefundNo: "",
    })
    setTimeout(() => {
      this.searchReceipt()
    }, 500);
  }

  handleKeyDown(e) {
    if (e.code == 'Enter') {
      this.searchReceipt()
    }
  }

  // to create excel file
  onCreateExcel() {
    const { excelList } = this.state
    var list = [...excelList]
    list.length > 0 && list.map(data => {
      delete data.BaseAmount
    })
    console.log("excelList", excelList)
    var columnArray = [],
      rowData = [];
    // for column data 
    list.map((data, index) => {
      if (index == 0) {
        Object.keys(data).map((key, index) => {
          columnArray.push(key)
        })
      }
    })

    // for row data
    list.map((data, index) => {
      rowData.push(data)
    })

    // console.log("rowData", rowData)
    // this.setState({
    //     columnArrayData: columnArray,
    //     rowData: rowData
    // })

    // { this.renderList() }
    console.log(rowData, columnArray, list)
    return (
      <div className="row text-center" >
        {excelList.length > 0 ? <Workbook filename="RefundList.xlsx" style={{}} element={
          <button type="button" className="btn ad-fil-btn m-0"
            disabled={!this.getWriteAccess()}
          >
            Excel
          </button>
        }>
          <Workbook.Sheet data={rowData} name="Sheet A">
            {columnArray.map((value, index) =>
              <Workbook.Column label={value} value={value} />
            )
            }
          </Workbook.Sheet>
        </Workbook> : <button type="button" className="btn ad-fil-btn m-0" disabled={true}>
          Excel
        </button>}
      </div>
    );
  }

  onShare(RefundID) {
    const { recptList } = this.state
    const RefundIDArray = []
    console.log("RefundIDArray RefundID ", RefundID)
    recptList.map((data) => {
      if (data.is_checked === 1) {
        RefundIDArray.push(
          {
            "RefundID": data.RefundID
          }
        )
      }
    })

    const singleRefundIDArray = []
    singleRefundIDArray.push(
      {
        "RefundID": RefundID
      }
    )

    console.log("RefundIDArray", RefundIDArray)

    this.setState({ isLoading: true })
    this.props
      .receiptShare_action(RefundID != undefined ? singleRefundIDArray : RefundIDArray)
      .then((data) => {
        if (data.error != 1) {
          console.log("receipt share !!!!!!!!!!!!", data.data);
          this.setState({ isLoading: false })
          toastSuccess("Receipt share successfully!", {
            theme: 'colored',
            autoClose: 500,
            hideProgressBar: true,
          })
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleListClick(e, id) {
    const { excelList, recptList, isAllChecked } = this.state
    var list = []
    recptList.map((data, index) => {
      if (data.RefundID === id) {
        if (e.target.checked) {
          data.is_checked = 1
          excelList.push(data)
        } else {
          data.is_checked = 0
          list = excelList.filter((data) => data.RefundID != id)
          this.setState({ excelList: list, isAllChecked: false })
        }
      }
    })

    this.setState({ recptList: recptList })
    const checkboxSelected = recptList.some(item => item.is_checked == 1)
    if (checkboxSelected) {
      this.setState({ checkBoxFlag: false })
    } else {
      this.setState({ checkBoxFlag: true })
    }

    const allSelected = recptList.every(item => item.is_checked == 1)

    if (allSelected) {
      this.setState({ isAllChecked: true })
    } else {
      this.setState({ isAllChecked: false })
    }

  }

  handleView(id) {
    this.props.navigate('/refundEntry', { state: { is_view: true, RefundID: id } })
  }

  handleUpdate(id) {
    this.props.navigate('/refundEntry', { state: { is_update: true, RefundID: id } })
  }

  handleNewRefund() {
    this.props.navigate('/refundEntry', { state: { is_add: true, From: "RefundList" } })
  }

  onSearchClick() {
    const { exhibitor, RefundFromDate, RefundToDate, RefundNo } = this.state
    if (exhibitor != "" || RefundFromDate != null || RefundToDate != null || RefundNo != "") {
      this.searchReceipt()
    } else {
      toastError("Atleast Fill One field to Search")
    }
  }

  onShare(RefundID) {
    const { recptList } = this.state
    const refundIDarray = []
    console.log("refundIDarray receiptId ", RefundID)
    recptList.map((data) => {
      if (data.is_checked === 1) {
        refundIDarray.push(
          {
            "RefundID": data.RefundID
          }
        )
      }
    })

    const singlerefundIDarray = []
    singlerefundIDarray.push(
      {
        "RefundID": RefundID
      }
    )

    console.log(singlerefundIDarray, "refundIDarray", refundIDarray)

    this.setState({ isLoading: true })
    this.props
      .refundShare_action(RefundID != undefined ? singlerefundIDarray : refundIDarray)
      .then((data) => {
        if (data.error != 1) {
          console.log("receipt share !!!!!!!!!!!!", data.data);
          this.setState({ isLoading: false })
          toastSuccess("Receipt share successfully!", {
            theme: 'colored',
            autoClose: 500,
            hideProgressBar: true,
          })
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  // on pdf receipt download
  onRefundDownload(E, id) {
    this.setState({ isLoading: true })
    this.props.getRefunedPdf_action(id)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false })
          console.log("Proforma Pdf Download", data)
          var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
          const win = window.location.replace(url, '_blank');
          if (win != null) {
            win.focus();
          }
        } else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((err) => {
        console.log(err)
      })

  }

  getWriteAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '2');
    if (moduleAccess) {
      return moduleAccess.WriteAccess;
    } else {
      return false
    }
    return false;
  }

  getDownloadAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '2');
    if (moduleAccess) {
      return moduleAccess.DownloadAccess;
    } else {
      return false
    }
    return false;
  }

  getSendAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '2');
    if (moduleAccess) {
      return moduleAccess.SendAccess;
    } else {
      return false
    }
    return false;
  }

  getUpdateAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '2');
    if (moduleAccess) {
      return moduleAccess.UpdateAccess;
    } else {
      return false
    }
    return false;
  }

  render() {
    const { exhibitor, RefundFromDate, RefundToDate, RefundNo, isLoading, currentPage, recptList, attachedment,
      RefundFromDateErr, RefundToDateErr, RefundNoErr, exhibitorErr, isOpen, ccEmail, toEmail, isAllChecked, fileList,
      taxableAmount, totalRefundAmt, checkBoxFlag } = this.state
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
    const currentRecords = recptList.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(recptList.length / recordsPerPage)




    // const { taxableAmount, totalCgst, totalIgst, totalSgst, totalRefundAmt } = this.calculateTotals()
    // const files = fileList ? [...fileList] : [];

    return (
      <>

        {isLoading ? (
          <Loader></Loader>
        ) : (
          null
        )}
        <ToastContainer />
        {
          JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
            <ExhibitorHeader /> : <HeaderWithLogo />
        }
        <div
          //  className="with-dr-container com-height"
          className={JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ? "with-dr-container" : "with-dr-container com-height"}
        >
          <div className="main-container">
            {
              JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                <ExhibitorDrawer /> : <AdminDrawer />
            }
            {
              JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                <ExhibitorTopMenu /> : null
            }

            <div className="row">
              <div className="step-name">
                <p>Refund</p>
              </div>
            </div>
          </div>
          <div className="main-container p-2 mt-1">
            {
              JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
              <div className="row ">
                <div className="col-xl-3 mb-3">
                  <label>Exhibitor</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue=""
                    required=""
                    value={exhibitor}
                    onKeyDown={e => this.handleKeyDown(e)}
                    onChange={(e) => this.setState({ exhibitor: e.target.value, exhibitorErr: "" })}
                  />
                  {/* {<span className='text-danger text-start text-left d-block mt-1'>{exhibitorErr}</span>} */}
                </div>
                <div className="col-xl-3 mb-3">
                  <label>Refund Date From</label>
                  <DatePicker className="form-control"
                    dateFormat="dd-MM-yyyy"
                    onKeyDown={e => this.handleKeyDown(e)}
                    onChange={(date) => this.setState({ RefundFromDate: date, RefundFromDateErr: "" })}
                    selected={this.state.RefundFromDate}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="From Date"
                    customInput={<ExampleCustomInput />}
                    dayClassName={() => "example-datepicker-day-class"}
                    popperClassName="example-datepicker-class"
                  />
                  {/* {<span className='text-danger text-start text-left d-block mt-1'>{RefundFromDateErr}</span>} */}
                </div>
                <div className="col-xl-3 mb-3">
                  <label>Refund Date To</label>
                  <DatePicker className="form-control"
                    dateFormat="dd-MM-yyyy"
                    minDate={this.state.RefundFromDate}
                    onKeyDown={e => this.handleKeyDown(e)}
                    onChange={(date) => this.setState({ RefundToDate: date, RefundToDateErr: "" })}
                    selected={this.state.RefundToDate}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="To Date"
                    customInput={<ExampleCustomInput />}
                    dayClassName={() => "example-datepicker-day-class"}
                    popperClassName="example-datepicker-class"
                  />
                  {/* {<span className='text-danger text-start text-left d-block mt-1'>{RefundToDateErr}</span>} */}
                </div>
                <div className="col-xl-3 mb-3">
                  <label>Refund No</label>
                  <input
                    type="text"
                    className="form-control"
                    id="validationCustom03"
                    value={RefundNo}
                    onKeyDown={e => this.handleKeyDown(e)}
                    onChange={(e) => this.setState({ RefundNo: e.target.value, RefundNoErr: "" })}
                  />
                  {/* {<span className='text-danger text-start text-left d-block mt-1'>{RefundNoErr}</span>} */}
                </div>
              </div>
            }
            <div className="row">
              <div className="col-md-12">
                {
                  JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                  <div
                    className="btn-group mb-1"
                    role="group"
                    aria-label="Basic example"
                    style={{ float: "right" }}
                  >
                    <button type="button" className="btn ad-fil-btn" onClick={e => this.onSearchClick()}>
                      Search
                    </button>
                    <button type="button" className="btn ad-fil-btn"
                      disabled={!this.getWriteAccess()}
                      onClick={e => this.handleNewRefund()} >
                      New Refund
                    </button>
                    {this.onCreateExcel()}
                    {/* <button type="button" className="btn ad-fil-btn" onClick={e => this.toggleModal()} >
                    onClick={e => this.toggleModal()}
                    Share
                  </button> */}
                    <button type="button"
                      disabled={checkBoxFlag || this.getSendAccess()}
                      className="btn ad-fil-btn" onClick={e => this.onShare()}>
                      Share
                    </button>

                    <button type="button" className="btn ad-fil-btn" onClick={e => this.clearValue()}>
                      Clear
                    </button>
                  </div>
                }
                <div className="table-responsive">
                  <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                    <thead>
                      <tr>
                        {
                          JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                          <th className="text-center">
                            <input type="checkbox" value={isAllChecked} checked={isAllChecked} onClick={e => this.handleAllSelected(e)} />
                          </th>
                        }
                        {/* <th>Reference No </th> */}
                        <th>Refund No</th>
                        {
                          JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                          <th>Company Name</th>
                        }
                        <th>Refund Date </th>
                        <th>Taxable Amount </th>
                        <th>Security Deposite </th>
                        <th>CGST </th>
                        <th>SGST </th>
                        <th>IGST </th>
                        <th>Refund Amount</th>
                        {
                          JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                          <th></th>
                        }
                        {
                          this.getUpdateAccess() &&
                          <th></th>
                        }
                        <th></th>
                        <th></th>
                        {/* <th></th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {
                        currentRecords.length > 0 ?
                          currentRecords.map((data, index) => (
                            <>
                              <tr >
                                {
                                  JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                  <td className="text-center">
                                    <input type="checkbox"
                                      value={data.is_checked}
                                      checked={data.is_checked}
                                      onClick={e => this.handleListClick(e, data.RefundID)} />
                                  </td>
                                }
                                {/* <td>{data.ReferenceNo}</td> */}
                                <td>{data.RefundNo}</td>
                                {
                                  JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                  <td>{data.ExhibitorName}</td>
                                }
                                <td>{data.RefundDate}</td>
                                <td>{data.TaxableAmount}</td>
                                <td>{data.SecurityDeposite}</td>
                                <td>{data.CGST}</td>
                                <td>{data.SGST}</td>
                                <td>{data.IGST}</td>
                                <td>{data.RefundAmount}</td>
                                {
                                  JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                  <td style={{ cursor: 'pointer' }}>
                                    <i className="fa fa-eye" aria-hidden="true" onClick={e => this.handleView(data.RefundID)}
                                    // disabled={!isRightToView}
                                    />
                                  </td>
                                }
                                {
                                  this.getUpdateAccess() &&
                                  <td style={{ cursor: 'pointer' }}>
                                    <i className="fa fa-pencil" aria-hidden="true" onClick={e => this.handleUpdate(data.RefundID)}
                                    // disabled={!isRightToEdit}
                                    />
                                  </td>
                                }
                                <td style={{ cursor: 'pointer' }}>
                                  <i className="fa fa-download" aria-hidden="true" onClick={(e) => this.onRefundDownload(e, data.RefundID)} />
                                </td>
                                <td style={{ cursor: 'pointer' }}>
                                  <i class="fa fa-share" onClick={(e) => this.onShare(data.RefundID)}></i>
                                </td>
                              </tr>
                            </>
                          )) : <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                      }
                      {
                        currentRecords.length > 0 &&
                        <tr>
                          {/* <td /> */}
                          {
                            JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                            <td />
                          }
                          {
                            JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                            <td />
                          }
                          <td />
                          <td />
                          <td>
                            <strong>{taxableAmount}</strong>
                          </td>
                          <td>
                            <strong>
                              {/* {this.state.totalSD} */}
                            </strong>
                          </td>
                          <td>
                            <strong></strong>
                          </td>
                          <td>
                            <strong></strong>
                          </td>
                          <td>
                            <strong></strong>
                          </td>
                          <td>
                            <strong>{totalRefundAmt}</strong>
                          </td>
                          <td />
                          <td />
                          {/* <td /> */}
                        </tr>
                      }

                    </tbody>
                  </table>
                </div>
                <div className="mt-2 float-left">
                  {
                    recptList.length > 0 ?
                      <Pagination
                        nPages={nPages}
                        currentPage={currentPage}
                        setCurrentPage={this.updateItem}
                      /> : <></>
                  }
                  <div className="tab-rec " style={{ float: "right" }}>
                    <p>{`${currentPage} of ${nPages} pages`}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {
          JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
          <Footerwithdr />
        }
      </>
    )
  }
}
export default withRouter(connect(null, { receipt_list_search_action, shareEmail_action, refundShare_action, getRefunedPdf_action, getEmailData_action, getReceiptPdf_action, receiptShare_action, get_receipt_list_action })(RefundList));